import { render } from "./OfflineMessage.vue?vue&type=template&id=54fd2b8c"
import script from "./OfflineMessage.vue?vue&type=script&lang=js"
export * from "./OfflineMessage.vue?vue&type=script&lang=js"

import "./OfflineMessage.vue?vue&type=style&index=0&id=54fd2b8c&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__